import { VIBE_ATTR_PATH } from '../constants/api';
import {
  EULA_CONFIRMATION,
  EULA_GANDALF_PROFILE_FIELD,
} from '../constants/auth';
import { UPDATE_EULA } from '../constants/metrics';
import { GandalfUser } from '../types/auth';
import { request, joinUrlPath } from '../utils/apiHelper';

export function isEulaAccepted(
  user: GandalfUser,
  consentAccepted: boolean | undefined
) {
  //This checks EULA on token and also check if EULA will be handled as part of Combined EULA workflow
  return (
    Boolean(user.eulaStatus?.toLowerCase() === EULA_CONFIRMATION) ||
    consentAccepted === true
  );
}

export async function acceptEula(
  gandalfProfileEndpoint: string,
  user: GandalfUser
) {
  if (!user.jwtToken) {
    throw new Error('User token not defined');
  }
  const opts: RequestInit = {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: user.jwtToken,
    },
    body: JSON.stringify({
      attributes: [
        {
          name: EULA_GANDALF_PROFILE_FIELD,
          attributeValue: {
            S: EULA_CONFIRMATION,
          },
        },
      ],
    }),
  };
  return request(joinUrlPath(gandalfProfileEndpoint, VIBE_ATTR_PATH), opts, {
    metricNs: UPDATE_EULA,
  }).then((response) => response.json());
}
